import React, { HTMLAttributes, ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";

interface IClassesProps {
    itemMinWidth: number;
}

const useStyles = (props: IClassesProps) =>
    makeStyles((theme: Theme) => {
        const itemMargin = theme.spacing(1);
        const { itemMinWidth } = props;

        return createStyles({
            root: { display: "flex", flexWrap: "wrap", margin: -itemMargin },
            item: {
                flex: "1 0 30%",
                minWidth: itemMinWidth,
                margin: itemMargin,
            },
            placeholderItem: {
                marginTop: 0,
                marginBottom: 0,
            },
        });
    });

interface IProps extends HTMLAttributes<HTMLDivElement> {
    items: ReactNode[];
    itemsInGrid?: number;
    itemMinWidth?: number;
}

export default function ItemGrid(props: IProps) {
    const { items, itemsInGrid = 6, itemMinWidth = 300, className, ...rest } = props;
    const classes = useStyles({ itemMinWidth })();

    const numberOfExtraItems = (itemsInGrid - (items.length % itemsInGrid)) % itemsInGrid;

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {items.map((item) => {
                return <div className={classes.item}>{item}</div>;
            })}
            {Array.from(Array(numberOfExtraItems)).map((item) => (
                <div className={clsx(classes.placeholderItem, classes.item)}>{item}</div>
            ))}
        </div>
    );
}
